import React, {useState} from "react";
import { Button, Column, Columns, Control, Field, Input, Modal, Section, Title } from "@allxsmith/bestax-bulma";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh} from "../../state/selectors";
import {ToastContainer, toast} from "react-toastify";
import VehicleTrackerTypePicker from "./TrackerTypePicker";
import useInput from "../../hooks/useInput";


export default function CreateTrackerModal({open, setOpen, endpoint, types, typeObjects}) {
  const dispatch = useDispatch();
  let dataFresh = useSelector(getDataFresh);
  let [tracker, setTracker] = useState({});
  const [, setTypeahead] = useState();
  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);

  const onClickAction = () => {
    if (checkAllFieldsFilled()) {
      save();
      setTracker({})
      setOpen(false);
    } else {
      toast.error("Please fill in all fields", {position: "top-right"});
    }
  };

  const handleSearch = e => {
    setLoading(true);
    axios.get(`/api/vehicles?search=${e}&tracker=BLANK`).then(resp => {
      setSearchData(resp.data.results.map(vehicle => ({...vehicle, display_name: vehicle.registration})));
      setLoading(false);
    });
  }

  const handleVehicleSelect = vehicles => {
    let newTracker = {...tracker}
    newTracker.vehicle = vehicles[0];
    setTracker(newTracker);
  };

  const handleChange = (e) => {
    let newTracker = {...tracker};
    newTracker[e.target.name] = e.target.value;
    setTracker(newTracker);
  };
  const handleTypeChange = (e) => {
    let newTracker = {...tracker};
    newTracker[e.target.name] = typeObjects[e.target.value];
    setTracker(newTracker);
  }
  const checkAllFieldsFilled = () => {
    return !(!tracker.hasOwnProperty('imei') || tracker.imei.length < 1 || !tracker.hasOwnProperty('type') || tracker.type.length < 1);
  };

  const [dateAssigned, dateAssignedInput,setDateAssigned] = useInput({
    type: "date",
    label: "Date Assigned",
    onChange: handleChange,
    name: "date_assigned",
  });
  const [dateActivated, dateActivatedInput,setDateActivated] = useInput({
    type: "date",
    label: "Date Activated",
    onChange: handleChange,
    name: "date_activated"
  });

  // Save an existing tracker
  const save = () => {
    const url = endpoint + "vehicletracker";
    const data = {
      ...tracker
    };
    if(data.vehicle){
      const {id, registration} = tracker.vehicle;
      data.vehicle = {id, registration};
    }
    const conf = {
      method: "post",
      data: tracker,
      url
    };
    return axios(conf).then(() => {
      dispatch(createSetDataFreshAction(dataFresh + 1));
      setOpen(false);
    });
  };

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal
      closeOnBlur
      active={open}
      nClick={e => {e.stopPropagation()}}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Modal.Content className="wider-modal">
        <Section style={{backgroundColor: "white"}}>
          <Title className="is-centered">Create New Tracker</Title>
          <Columns isMultiline>
            <Column>
              <Field>
                <label className="label">IMEI</label>
                <Control>
                  <Input
                    type="text"
                    name="imei"
                    onChange={handleChange}
                    value={tracker.imei || ""}
                    required
                  />
                </Control>
              </Field>
            </Column>
            <Column>
              <Field>
                <label className="label">Vehicle</label>
                <Control>
                  <AsyncTypeahead
                      useCache={false}
                      id="typeahead"
                      labelKey="display_name"
                      minLength={2}
                      name={"vehicle"}
                      onSearch={handleSearch}
                      onChange={handleVehicleSelect}
                      placeholder={"Search Vehicle Registration"}
                      options={searchData}
                      ref={typeahead => setTypeahead(typeahead)}
                      className="typeahead"
                      isLoading={isLoading}
                      selected={tracker.vehicle && tracker.vehicle.id ? [tracker.vehicle] : []}
                  />
                </Control>
              </Field>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <label className="label">Tracker Type</label>
              <VehicleTrackerTypePicker
                dataFresh={dataFresh}
                tracker={tracker}
                types={types}
                editable={true}
                updateValue={handleTypeChange}
                inLineEdit={false}
              />
            </Column>
            {dateAssignedInput}
            {dateActivatedInput}
          </Columns>
          <Columns isMultiline>
            <Column>
              <Button
                  color="info"
                  onClick={() => {
                    setTracker({});
                    setOpen(false);
                  }}
                  isFullWidth
              >
                Cancel
              </Button>
            </Column>
            <Column>
              <Button color="danger" onClick={onClickAction} isFullWidth>
                Save Tracker
              </Button>
            </Column>
          </Columns>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
